import { Link } from "gatsby"
import React from "react"

import styles from "./IconLink.module.scss"

const IconLink = ({
  icon,
  href,
  text,
  internal = true,
  target = "_blank",
  element = "li",
}) => {
  const Element = element
  return (
    <Element className={styles.item}>
      {internal && (
        <Link to={href}>
          {icon && (
            <img className={styles.icon} src={icon} alt="" aria-hidden="true" />
          )}
          <span>{text}</span>
        </Link>
      )}
      {!internal && (
        <a href={href} target={target} rel="noopener noreferrer">
          {icon && (
            <img className={styles.icon} src={icon} alt="" aria-hidden="true" />
          )}
          <span>{text}</span>
        </a>
      )}
    </Element>
  )
}

export default IconLink
